import { z } from "zod";
export { getOpenAIVideoModelProfile, isOpenAIVideoModel, OPENAI_VIDEO_MODEL_PROFILES, OPENAI_VIDEO_MODELS, openAIVideoModelSchema, updateVideoModelSchema, } from "./video-models.js";
export const VIDEO_DURATIONS = [4, 8, 12, 16, 20];
export const STYLE_PRESETS = [
    "neon-rain",
    "cozy-night",
    "dream-garden",
    "retro-space",
];
export const VIDEO_PLATFORMS = [
    "tiktok",
    "youtube-shorts",
    "youtube-video",
    "instagram-story",
    "instagram-reels",
];
export const VIDEO_FRAME_RATES = [24, 30, 60];
export const VIDEO_PLATFORM_SPECS = {
    tiktok: {
        label: "TikTok",
        width: 1080,
        height: 1920,
        aspectRatio: "9:16",
        container: "mp4",
        minimumFrameRate: 24,
    },
    "youtube-shorts": {
        label: "YouTube Shorts",
        width: 1080,
        height: 1920,
        aspectRatio: "9:16",
        container: "mp4",
        minimumFrameRate: 24,
    },
    "youtube-video": {
        label: "YouTube Video",
        width: 1920,
        height: 1080,
        aspectRatio: "16:9",
        container: "mp4",
        minimumFrameRate: 24,
    },
    "instagram-story": {
        label: "Instagram Story",
        width: 1080,
        height: 1920,
        aspectRatio: "9:16",
        container: "mp4",
        minimumFrameRate: 24,
    },
    "instagram-reels": {
        label: "Instagram Reels",
        width: 1080,
        height: 1920,
        aspectRatio: "9:16",
        container: "mp4",
        minimumFrameRate: 30,
    },
};
export const createJobSchema = z
    .object({
    story: z
        .string()
        .trim()
        .min(12, "Describe the scene in at least 12 characters.")
        .max(4_000),
    durationSeconds: z
        .number()
        .int()
        .refine((value) => VIDEO_DURATIONS.includes(value)),
    stylePreset: z.enum(STYLE_PRESETS),
    platform: z.enum(VIDEO_PLATFORMS).default("tiktok"),
    frameRate: z
        .number()
        .int()
        .refine((value) => VIDEO_FRAME_RATES.includes(value))
        .default(30),
})
    .superRefine((input, context) => {
    if (input.frameRate < VIDEO_PLATFORM_SPECS[input.platform].minimumFrameRate)
        context.addIssue({
            code: "custom",
            path: ["frameRate"],
            message: `${VIDEO_PLATFORM_SPECS[input.platform].label} requires at least ${String(VIDEO_PLATFORM_SPECS[input.platform].minimumFrameRate)} fps.`,
        });
});
export function toPublicJob(job) {
    return {
        id: job.id,
        story: job.story,
        durationSeconds: job.durationSeconds,
        stylePreset: job.stylePreset,
        platform: job.platform,
        frameRate: job.frameRate,
        outputWidth: job.outputWidth,
        outputHeight: job.outputHeight,
        outputContainer: job.outputContainer,
        videoModel: job.videoModel,
        status: job.status,
        progress: job.progress,
        errorMessage: job.errorMessage,
        createdAt: job.createdAt,
        completedAt: job.completedAt,
    };
}
//# sourceMappingURL=index.js.map